import { StepBackwardOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const BackNavBtn = ({
  icon,
  displayText = true,
  text = null,
  ...others
}) => {
  return (
    <Button icon={!icon ? <StepBackwardOutlined /> : icon} {...others}>
      {displayText && (text == null ? "Anterior" : text)}
    </Button>
  );
};
